"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouter = require("@tanstack/react-router");
var _styledComponentThemes = require("../../../../_nextgen/packages/styled-component-themes");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _analytics = _interopRequireWildcard(require("../../../../packages/analytics"));
var _new = require("../../new.helper");
var Styled = _interopRequireWildcard(require("./index.styled"));
var Themes = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const CompareVehicleToggle = function (props) {
  const {
    text,
    vehicle,
    vehicles,
    onChange
  } = props;
  const fireAnalytics = (0, _analytics.default)("CompareVehicleToggle");
  const {
    model
  } = (0, _reactRouter.useParams)();
  const [, addToCompareVehicleCookie] = (0, _new.compareVehicleHandlerStorage)(model);
  const handleOnChange = function (event) {
    if (onChange) onChange(event, vehicle);
    let checked = false;
    if (event.target instanceof HTMLInputElement) {
      checked = event.target.checked;
    }
    fireAnalytics("click", {
      checked: checked,
      Checkbox: checked
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: props === null || props === void 0 ? void 0 : props.className,
    "data-testid": "CompareVehicleToggle",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.CompareVehicleToggle, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: "checkbox",
        checked: typeof vehicle === "object" ? vehicles === null || vehicles === void 0 ? void 0 : vehicles.some(function (i) {
          return i.vin === vehicle.vin;
        }) : vehicles === null || vehicles === void 0 ? void 0 : vehicles.includes(vehicle),
        name: "compare-vehicle-toggle",
        value: `${typeof vehicle === "object" ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin : vehicle}-text`,
        "aria-label": `${typeof vehicle === "object" ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin : vehicle}-compare-vehicle-toggle`,
        onChange: handleOnChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Checkbox, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: text
        })
      })]
    }, `${typeof vehicle === "object" ? vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin : vehicle}-compare-vehicle`)
  });
};
const ThemedCompareVehicleToggle = (0, _styledComponentThemes.withThemes)(CompareVehicleToggle, Themes);
var _default = exports.default = (0, _analytics.withAnalytics)(ThemedCompareVehicleToggle)({});